<template>
  <div
    id="map-screen"
    Disabled_data-aos="zoom-out-right"
    Disabled_data-aos-duration="2400"
  >
    <gmap-map
      id="map"
      ref="gmap"
      :center="center"
      :zoom="zoom_"
      :options="mapOptions"
      @zoom_changed="changeZoom"
    >
      <gmap-cluster
        :zoomOnClick="true"
        :maxZoom="14.9"
        :batchSizeIE="32"
        :imageSizes="[32, 32]"
        :styles="cluster_styles"
      >
        <gmap-marker
          :key="index"
          v-for="(m, index) in markers_c"
          :title="m.type ? m.type : ''"
          :position="m.position"
          :icon="m.icon"
          :label="m.icon.label"
          @click="openInfoModal(m)"
        />

        <gmap-marker
          :key="index + '-transit'"
          v-for="(transit, index) in markers_transit"
          :title="$t('title_icono_transito')"
          :position="transit.position"
          :icon="transit.icon"
          :label="transit.icon.label"
          @click="openTransitModal(transit)"
        />
      </gmap-cluster>
    </gmap-map>
  </div>
</template>

<script>
import _ from "lodash";
import GmapCluster from "vue2-google-maps/dist/components/cluster"; // replace src with dist if you have Babel issues
import GmapOptions from "../utilities/MapOptions.js";
import * as vallas_request from "../request/vallas.js";
import * as transit_request from "../request/transit.js";
import * as usage_request from "../request/usage.js";
import { mapGetters } from "vuex";

//mixins
import VallasMixin from "../mixins/vallas";

export default {
  components: {
    "gmap-cluster": GmapCluster,
  },
  mixins: [VallasMixin],
  props: [
    "cardinal_directions",
    "ciudades",
    "locationes",
    "grupos",
    "transitos",
    "types",
  ],
  async mounted() {
    let vm = this;
    // Evento para cambiar el centro del mapa
    $("#city-button-change").change(function (event) {
      vm.changeCenter(event.target.value);
    });
    await this.$refs.gmap.$gmapApiPromiseLazy();

    vm.defaultOpenInfoModal();
    vm.resetPasswordModal();
  },
  computed: {
    markers_c: function () {
      let result = [];
      _.forEach(this.markers, (o) => {
        if (o) {
          result.push(o);
        }
      });
      return result;
    },
    ...mapGetters(["getUser", "getToken"]),
  },
  watch: {
    ciudades: function (value) {
      if (value.length > 0) {
        this.setCenterParams();
      }
    },
  },
  data() {
    return {
      center: { lat: 18.455667, lng: -69.940194 },
      zoom_: 14,
      zoomSplit: 19, // Si el zoom es mayor a este valor
      mapOptions: GmapOptions,
      markers: [],
      shwo_groups: false,
      cluster_styles: [
        {
          url: window.url_api + "/img/cluster1.png",
          height: 34,
          width: 34,
          textColor: "#FFFFFF",
          textSize: 16,
          fontFamily: "Encode Sans Semi Condensed, Arial, sans-serif",
        },
      ],
      markers_transit: [],
    };
  },
  methods: {
    createMarkers() {
      let vm = this;
      // Los Markers de los grupos y vallas individuales
      this.markers = [];
      _.forEach(this.locationes, function (location) {
        let IsInGroup = _.find(vm.grupos, { billboard_id: location.id });
        let type_ = _.find(vm.types, { id: location.type_id });
        if (IsInGroup && !vm.shwo_groups) {
          if (!_.find(vm.markers, { id_grupo: IsInGroup.group_id })) {
            let grupo_ = _.find(vm.grupos, { billboard_id: location.id });
            vm.markers.push({
              id_valla: location.id,
              id_grupo: grupo_.group_id,
              grupo: grupo_,
              position: {
                lat: parseFloat(grupo_.latitude),
                lng: parseFloat(grupo_.longitude),
              },
              icon: vm.getIcon("", true, grupo_),
              type: type_.name,
            });
          }
        } else {
          vm.markers.push({
            id_valla: location.id,
            position: {
              lat: parseFloat(location.latitude),
              lng: parseFloat(location.longitude),
            },
            icon: vm.getIcon(location.type_id),
            type: type_.name,
          });
        }
      });
      // agregar los Transitos
      _.forEach(this.transitos, (location) => {
        vm.markers_transit.push({
          id: location.id,
          position: {
            lat: parseFloat(location.latitude),
            lng: parseFloat(location.longitude),
          },
          icon: vm.getIcon("transit"),
        });
      });
    },
    getIcon(type, group_icon, group_) {
      var url_img = "";

      if (group_icon) {
        if (group_.group_type === "transport-station") {
          return {
            url: "/img/icons-type/train-icon.svg",
            color: "#D71B07",
            scaledSize: new google.maps.Size(32, 32),
            origin: new google.maps.Point(0, 0),
            anchor:
              type == "transit"
                ? new google.maps.Point(26, 32)
                : new google.maps.Point(16, 32),
          };
        }

        return {
          path: google.maps.SymbolPath.CIRCLE,
          class: "group-icon",
          fillOpacity: 1,
          fillColor: group_.group_type === "mall" ? "#b2e3aa" : "#D71B07",
          strokeWeight: 0,
          scale: 17,
          label: {
            color: "#fff",
            fontSize: "16px",
            fontWeight: "800",
            fontFamily: "Encode Sans Semi Condensed",
            text: _.toString(
              _.filter(this.grupos, { group_id: group_.group_id }).length
            ),
          },
        };
      } else {
        url_img = "icon-type-" + type + ".png";
      }
      if (group_) {
        url_img = "BoardMarkerGroupBackground.png";
      }

      return {
        url: "/img/icons-type/" + url_img,
        scaledSize: group_
          ? new google.maps.Size(60, 60)
          : group_icon
          ? new google.maps.Size(32, 32)
          : new google.maps.Size(32, 32),
        origin: new google.maps.Point(0, 0),
        anchor:
          type == "transit"
            ? new google.maps.Point(26, 32)
            : new google.maps.Point(16, 32),
      };
    },
    openInfoModal(marker) {
      var vm = this;
      if (marker.id_grupo) {
        vm.$parent.$refs.grupos_valla_modal.show(marker.id_grupo, marker.grupo);
      } else {
        // Usage Unit and Dialy: views
        usage_request.post({
          views: 1,
          id_billboard: marker.id_valla,
        });
        vallas_request.get(marker.id_valla).then(function (response) {
          vm.$parent.$refs.detalles_valla_modal.show(response.data.data);
        });
      }
    },
    openTransitModal(marker) {
      var vm = this;
      vm.$parent.$refs.detalles_transit_modal.show();
      transit_request.get(marker.id).then(function (response) {
        vm.$parent.$refs.detalles_transit_modal.setInfo(response.data.data);
      });
    },
    // Evento al cambiar el zoom
    changeZoom(level_zoom) {
      if (level_zoom > this.zoomSplit) {
        this.shwo_groups = true;
        this.createMarkers();
      } else {
        if (this.shwo_groups) {
          this.shwo_groups = false;
          this.createMarkers();
        }
      }
    },
    changeCenter(id_ciudad) {
      let ciudad = null;
      if (id_ciudad) {
        ciudad = _.find(this.ciudades, { id: parseInt(id_ciudad) });
        document.querySelectorAll("#city-button-change select")[0].value =
          id_ciudad;
        this.zoom_ = parseInt(ciudad.zoom);
      } else {
        ciudad = _.find(this.ciudades, { id: 2 });
        this.zoom_ = parseInt(ciudad.zoom);
      }
      this.center = {
        lat: parseFloat(ciudad.latitude),
        lng: parseFloat(ciudad.longitude),
      };
    },
    defaultOpenInfoModal() {
      var vm = this;
      let result = this.getParams(window.location.href);
      if (result.hasOwnProperty("id")) {
        vm.openInfoModal({ id_valla: result.id });
      }
    },
    resetPasswordModal() {
      var vm = this;
      let result = this.getParams(window.location.href);

      if(result.hasOwnProperty('reset_pw') && result.reset_pw == "1" && result.hasOwnProperty('token') && result.hasOwnProperty('email')) {
        vm.$parent.$refs.reset_password_form.show(result.token, result.email)
      }
    },
    setCenterParams() {
      let result = this.getParams(window.location.href);
      if (result.hasOwnProperty("go")) {
        let queryParamater = result.go;
        let array = document.querySelectorAll("#city-button-change select")[0]
          .options;
        for (let index = 0; index < array.length; index++) {
          const element = array[index];
          if (
            element.innerHTML.toLowerCase().replace(/\s+/g, "") ==
            queryParamater
          ) {
            setTimeout(() => {
              this.changeCenter(element.value);
            }, 500);
          }
        }
      }
    },
    getParams(url) {
      var params = {};
      var parser = document.createElement("a");
      parser.href = url;
      var query = parser.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        params[pair[0]] = decodeURIComponent(pair[1]);
      }
      return params;
    },
  },
};
</script>

<i18n src="@/locale/layout/global.json" />
